export default {
    availableEmployeeRoles () {
        return [
            { label: 'Garçom', value: 2 },
            { label: 'Gestor', value: 1 },
            { label: 'Administrador', value: 0 }
        ]
    }
}